import TabFinance from '@/components/comptable/dashboard/tab-finance'
import TabDMP from '@/components/comptable/dashboard/tab-dmp'
import store_config from "@/store/mods/parametres/config"
// import $ from 'jquery'

export default {
    name: 'dashboard',
    components: {
        TabFinance, TabDMP
    },
    props: [],
    data () {
        return {
            config_to_show: 'finance',
            liste_personnel_roles: []
        }
    },

    watch: {
        
    },

    computed: {
        
    },

    mounted () {
        this.fetchListeCaissieres()
    },

    methods: {
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },

        fetchListeCaissieres() {
            store_config.selectListeCaissieres().then((response) => {
                this.liste_personnel_roles = response
                const all_user = {
                    id: "",
                    nom: 'Tous(tes) les caissiers(es)',
                    titre: "",
                }
                this.liste_personnel_roles.unshift(all_user)
            })
        },
    }
}